module.exports = __webpack_public_path__ + "themes/mf/img/logo-game@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/logo-game@2x.png
// module id = 76
// module chunks = 3